
import {Component, Prop, Vue} from 'vue-property-decorator';

@Component({
  name: 'catalog-product-size-chart'
})

export default class extends Vue {
  @Prop({required: true}) private readonly productId: number;
  @Prop() private readonly isOpen: boolean;

  private sizeChartIsVisible: boolean = true;

  private get sizeChart(): null | object {
    return this.$store.getters['CatalogProductView/getSizeChart'];
  }

  private get sizeChartIsLoading(): boolean {
    return this.$store.getters['CatalogProductView/getSizeChartIsLoading'];
  }

  private mounted(): void {
    this.sizeChartIsVisible = this.isOpen;
  }
}
